import { tags } from "./resource";

const key = `
id
sk
workspaceId
`;

export const base = `
${key}
bankId
createdAt
idInc
idVendor
schemaVersion
type
updatedAt
version
workspaceId
`;

export const baseResource = `
bankId
creatorId
description
grade
language
idInc
idVendor
isDeleted
isUnlisted
keywords
maturity
name
subject
type
version
visibility
${tags}
`;

export const baseWorkspace = `
${key}
name
`;

export const blueprint = `
blueprintSpecs
`;

export const meta = `
author
blooms
dok
excerpt
flesch
lexile
lexileMin
lexileMax
parccTextComplexity
rmm
courseIds
wordCount
scoringMethod
fontScaling
dueAt
isCreating
`;

export const canvas = `
id
type
interactionType
content
config
scoring
`;

export const content = `
content {
  canvas {
    ${canvas}
  }
  forms {
    name
    type
    config
    sections {
      name
      type
      config
      questionIds
    }
  }
  body
  rubric
}
`;

export const user = `
${key}
firstName
lastName
email
avatarHash
acl
createdAt
updatedAt
notification {
  type
  payload
}
`;

export const objective = `
id
sk
type
name
authorityId
idPublisher
content
abbreviation
outlineNumber
scope
sequence
createdAt
updatedAt
`;

export const context = `
${key}
workspaceId
idInc
idVendor
type
version
maturity
content {
  body
}
file {
  bucket
  name
  key
  size
}
name
description
createdAt
updatedAt
`;

export const contexts = `
items {
  ${context}
}
nextToken
`;

export const file = `
name
key
size
mimetype
`;

export const dimensions = `
width
height
scale
`;

export const workspace = `
${key}
name
description
createdAt
updatedAt
workspaceId
invitationId
status
acl
counter
isDisabled
isDeleted
`;

export const keysResultItemType = `
id
sk
`;
